export function validateBounce(priceToBreak) {
  if (!priceToBreak || priceToBreak === '')
    return [false, 'Must enter a price to bounce.'];
  if (Number(priceToBreak) <= 0)
    return [false, 'Bounce Price must be larger than zero.'];
  return [true, ''];
}
